import esJson from '../../translations/es.json';
import zhJson from '../../translations/zh.json';
export default {
    es: esJson,
    zh: zhJson,
};
